import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 112,
		y: 72,
		width: 104,
		height: 368,
		rx: 30
	}), /* @__PURE__ */ _jsx("rect", {
		x: 296,
		y: 72,
		width: 104,
		height: 368,
		rx: 30
	})]
});
export default SvgPause;
